<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="400"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="navigation-head">
            <span>{{ titleForm }}</span>                         
        </div>

        <div class="pl-3 pt-3 pr-3" style="height: 80vh;">                
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="auxMotivo"
                            ref="name" 
                            label="Motivo" 
                            outlined 
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="auxMonto"
                            ref="name" 
                            label="Monto" 
                            prefix="S/"
                            outlined 
                            hide-details="auto"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-btn dark color="success" block height="40" @click="guardaDescuento">
                            <v-icon class="mr-1" size="16">far fa-save</v-icon>
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row cols="12" v-for="itemcito of auxDescuentos"  v-bind:key="itemcito.id" style="display: flex;align-items: center;">
                    <v-col cols="4"> 
                        <span>{{itemcito.motivo.toUpperCase()}}</span>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field 
                            :value="itemcito.monto"
                            outlined
                            type="number"
                            hide-details
                            prefix="S/"
                            disabled
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-btn
                            tile
                            color="red"
                            style="color:white;text-align: center;"
                            @click="eliminarDescuento(itemcito.motivo)"
                        >
                            <v-icon left>
                                mdi-minus-circle
                            </v-icon>
                            eliminar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>                 
        </div>

        <div class="mt-3 pl-3 pt-3 pr-3">
            <template>
                <v-row>
                    <v-col cols="12">
                        <v-btn block height="40" dark color="red" @click="handleCancel">
                            <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
                            Cerrar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>               
            
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapActions} from 'vuex'
import router from '@/router/index'
    
export default {
    name: 'CrearDescuento',
    data() {
        return {
            drawer: false,
            titleForm: null,
            action: null,
            auxMotivo: null,
            auxMonto: null,
            descuentos: [],
            id: null,
            auxDescuentos : [],
            auxEmpleado: [],
            totalDescuento: null,
            actualizaTotal: 0.00,
        }
    },
    methods: {
        ...mapActions('planillaDetalle',[
            'actualizaEmpleado',
            'getItems',
        ]),
        async showForm(title, item, total) {
            this.actualizaTotal = total;
            this.auxDescuentos = [];
            this.auxEmpleado = item
            this.totalDescuento = item.totalDescuento;
            let obser = this.auxEmpleado.descuento;
            localStorage.setItem('descuentos', obser);
            //console.log(obser == null);
            //console.log(obser)
            //console.log(typeof obser === 'string');
            //console.log('fin');
            let areglo = localStorage.getItem('descuentos');
            //console.log(areglo);
            if (obser == null) {
                this.auxDescuentos = [];
            }else{
                if (typeof obser === 'string') {
                    this.auxDescuentos = JSON.parse(obser);
                } else {
                    this.auxDescuentos = obser
                }
            }
            //console.log(areglo);
            this.newItem = item.id;
            //console.log(this.auxEmpleado)
            this.titleForm = title;
            this.drawer = !this.drawer;
        },
        calculaPagarDiasLab(item){
                //console.log(item);
                item.monto_diasLab_hExtra = 0;
                item.monto_descRegimen = 0
                item.totalSistemaSalud = 0
                if (item.dias_laborales < 7) {
                    
                    let auxPagarLab = item.valor_dia * (parseFloat(item.dias_laborales));
                    item.monto_pagar_laborales = auxPagarLab.toFixed(2);
                }
                if (item.dias_laborales >=7 && item.dias_laborales <12) {
                    let auxPagarLab = item.valor_dia * (parseFloat(item.dias_laborales) + 1);
                    item.monto_pagar_laborales = auxPagarLab.toFixed(2);
                }
                if (item.dias_laborales >=12 && item.dias_laborales <18) {
                    let auxPagarLab = item.valor_dia * (parseFloat(item.dias_laborales) + 2);
                    item.monto_pagar_laborales = auxPagarLab.toFixed(2);
                }
                if (item.dias_laborales >=18 && item.dias_laborales <24) {
                    let auxPagarLab = item.valor_dia * (parseFloat(item.dias_laborales) + 3);
                    item.monto_pagar_laborales = auxPagarLab.toFixed(2);
                }
                if (item.dias_laborales >=24 && item.dias_laborales <26) {
                    let auxPagarLab = item.valor_dia * (parseFloat(item.dias_laborales) + 4);
                    item.monto_pagar_laborales = auxPagarLab.toFixed(2);
                }
                if (item.dias_laborales >= 26) {
                    item.monto_pagar_laborales = item.remuneracion
                }
                suma = 0;
                let suma = parseFloat(item.monto_diasLab_hExtra) + parseFloat(item.monto_pagar_laborales) + parseFloat(item.monto_pagar_hExtra)
                item.monto_diasLab_hExtra = ((suma * 100) / 100).toFixed(2);
                let porcentaje = (item.monto_diasLab_hExtra * item.monto_regimen)/100
                item.monto_descRegimen = ((porcentaje * 100) / 100).toFixed(2);
                if (item.sistemaSalud == 'ESSALUD') {
                    let montoSeguro = (((item.monto_diasLab_hExtra * 0.09) * 100)/100).toFixed(2) - (item.monto_seguro_empresa).toFixed(2);
                    item.totalSistemaSalud = montoSeguro;
                } else {
                    item.totalSistemaSalud = 0.00;
                }
                let total = parseFloat(item.monto_diasLab_hExtra) + parseFloat(item.totalBonos) - (parseFloat(item.totalSistemaSalud) + parseFloat(item.monto_descRegimen) + parseFloat(item.totalDescuento))
                //console.log('total : '+total)
                item.totalPagar = total.toFixed(2);
                //this.totalPlanilla()
            },
            calculaPagarHorasLab(item){
                item.monto_diasLab_hExtra = 0;
                item.monto_descRegimen = 0
                let extra = item.valor_hExtra * item.horas_extra
                item.monto_pagar_hExtra = ((extra*100)/100).toFixed(2);
                //console.log(item.horas_extra)
                //console.log(item.valor_hExtra)
                suma = 0;
                let suma = parseFloat(item.monto_diasLab_hExtra) + parseFloat(item.monto_pagar_laborales) + parseFloat(item.monto_pagar_hExtra)
                //console.log(suma);
                item.monto_diasLab_hExtra = ((suma * 100) / 100).toFixed(2);
                let porcentaje = (item.monto_diasLab_hExtra * item.monto_regimen)/100
                //console.log(porcentaje);
                item.monto_descRegimen = ((porcentaje * 100) / 100).toFixed(2);
                if (item.sistemaSalud == 'ESSALUD') {
                    let montoSeguro = (((item.monto_diasLab_hExtra * 0.09) * 100)/100).toFixed(2);
                    item.totalSistemaSalud = montoSeguro;
                } else {
                    item.totalSistemaSalud = 0.00;
                }
                let total = parseFloat(item.monto_diasLab_hExtra) + parseFloat(item.totalBonos) - (parseFloat(item.totalSistemaSalud) + parseFloat(item.monto_descRegimen) + parseFloat(item.totalDescuento))
                item.totalPagar = total.toFixed(2);
                //this.totalPlanilla()
            },
        async guardaDescuento(){
            let element = {
                // 'id': this.newItem,
                'motivo': this.auxMotivo.toUpperCase(),
                'monto': this.auxMonto
            }
            this.totalDescuento = parseInt(this.totalDescuento) + parseInt(this.auxMonto);
            this.auxDescuentos.push(element);
            this.auxEmpleado.descuento = this.auxDescuentos ;
            this.auxEmpleado.totalDescuento = this.totalDescuento;
            let totalAct = parseFloat(this.auxEmpleado.totalPagar) - parseFloat(this.auxMonto);
            this.auxEmpleado.totalPagar = parseFloat(totalAct).toFixed(2);
            /*let totalcito = parseFloat(this.actualizaTotal) - parseFloat(this.totalDescuento);
            this.actualizaTotal = parseFloat(totalcito).toFixed(2);*/
            this.actualizaEmpleado(this.auxEmpleado);
            this.clearData();
        },
        eliminarDescuento(motivo){
            this.totalDescuento = 0
            let agrego = [];
            agrego = this.auxDescuentos;
            this.auxDescuentos = []
            for (let i = 0; i < agrego.length; i++) {
                if (agrego[i].motivo != motivo) {
                    this.auxDescuentos.push(agrego[i]);
                    this.totalDescuento = parseInt(this.totalDescuento) + parseInt(agrego[i].monto);
                }else{
                    let montito = agrego[i].monto;
                    let actualiza2 = parseFloat(this.auxEmpleado.totalPagar) +parseFloat(montito);
                    this.auxEmpleado.totalPagar = parseFloat(actualiza2).toFixed(2);
                }
                
            }
            this.auxEmpleado.descuento = this.auxDescuentos;
            this.auxEmpleado.totalDescuento = this.totalDescuento;
            this.actualizaEmpleado(this.auxEmpleado);
            this.clearData();
        },
        handleCancel() {
            this.closeForm();
        },
        closeForm() {
            this.clearData();
            this.drawer = false;
        },
        clearData() {
            this.auxMotivo = null;
            this.auxMonto = null; 
        },
    }
    
}
</script>

<style scoped>
</style>